export default "__VITE_ASSET__43a04143__"